import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { hasAccess } from '../../utils/permissionHelper';
import { FaCog, FaFileAlt, FaChevronDown, FaBox } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const isActive = path => location.pathname === path;
  const user = JSON.parse(localStorage.getItem("user"));
  const role = localStorage.getItem("role");
  const checkRole = localStorage.getItem("checkRole");
  const [settingOpen, setSettingOpen] = useState(false);
  const firstName = user?.firstName || user?.first_name || user?.fname || '';
  const lastName = user?.lastName || user?.last_name || user?.lname || '';
  const name = (firstName || lastName)
    ? `${firstName} ${lastName}`.trim()
    : (user?.displayName || user?.name || user?.username || user?.email || '');
  const userId = user?.id || user?.userId || user?._id || user?.clientId || '';
  const clientViewPath = userId ? `/user/client/view/${userId}` : '/user/client/view';

  const handleSettingClick = (e) => {
    e.preventDefault();
    setSettingOpen((prev) => !prev);
  };

  return (
    <div data-simplebar className="h-100">
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title"></li>
          {checkRole === "SuperAdmin" ? (
            <>
            
              <li className={isActive("/admin") ? 'mm-active' : ''}>
                <NavLink to="/admin" className="waves-effect">
                  <i className="mdi mdi-view-dashboard"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>
             {hasAccess(user, "Client registration") && (
                <li className={isActive("/admin/client") ? 'mm-active' : ''}>
                  <NavLink to="/admin/client" className="waves-effect">
                   <i class="fas fa-user-friends"></i>
                    <span>Client Registration</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Item Master") && (
                <li className={isActive("/admin/item") ? 'mm-active' : ''}>
                  <NavLink to="/admin/item" className="waves-effect">
                   <i className="fas fa-clipboard-check"></i>
                    <span>Item Master</span>
                  </NavLink>
                </li>
              )}
              
              {hasAccess(user, "Price List") && (
                <li className={isActive("/admin/price") ? 'mm-active' : ''}>
                  <NavLink to="/admin/price" className="waves-effect">
                  <i className="fas fa-tags"></i>
                    <span>Price List</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Order Master") && (
                <li className={isActive("/admin/order") ? 'mm-active' : ''}>
                  <NavLink to="/admin/order" className="waves-effect">
                  <i className="fas fa-shopping-cart"></i>
                    <span>Order Master</span>
                  </NavLink>
                </li>
              )}
              {/* Setting submenu */}
              <li>
                <a
                  href="#"
                  className="has-arrow waves-effect"
                  aria-expanded={settingOpen}
                  onClick={handleSettingClick}
                >
                  <i className="dripicons-gear"></i>
                  <span>Setting</span>
                </a>
                <ul
                  className="sub-menu mm-collapse"
                  aria-expanded={settingOpen}
                  style={{
                    height: settingOpen ? "auto" : "0px",
                    overflow: "hidden",
                    transition: "height 0.3s"
                  }}
                >
                    <li className={isActive("/admin/adminRole") ? "mm-active" : ""}>
                      <NavLink to="/admin/userRole" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>User & Role</span>
                      </NavLink>
                    </li>
                  {hasAccess(user, "Item Setting") && (
                    <li className={isActive("/admin/itemManage") ? "mm-active" : ""}>
                      <NavLink to="/admin/itemManage" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>Item Setting</span>
                      </NavLink>
                    </li>
                  )}
                  {hasAccess(user, "Master") && (
                    <li className={isActive("/admin/setting") ? "mm-active" : ""}>
                      <NavLink to="/admin/setting" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>Master</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            </>
          ) : (
            <>
              {/* USER DASHBOARD - permission-based visibility */}
              <li className={isActive("/user") ? 'mm-active' : ''}>
                <NavLink to="/user" className="waves-effect">
                  <i className="mdi mdi-view-dashboard"></i>
                  <span>Item Master</span>
                </NavLink>
              </li>
                
                <li className={isActive("/user/order") ? 'mm-active' : ''}>
                  <NavLink to="/user/order" className="waves-effect">
                  <i className="fas fa-shopping-cart me-2"></i>
                    <span>Order Master </span>
                  </NavLink>
                </li>
                
                <li className={location.pathname.startsWith("/user/client/view") ? 'mm-active' : ''}>
                  <NavLink to={clientViewPath} className="waves-effect">
                    <i className="fas fa-user-friends me-2"></i>
                    {name && <span>{name}</span>}
                  </NavLink>
                </li>
              
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;